import { useMutation } from '@apollo/client'
import { graphql } from '@apollo/client/react/hoc'

import { appliedFiltersToGraphQLVariables } from 'utils/filters/utils'

import { atlasClient } from 'graphql/client'
import { atlas, graphene } from 'graphql/tags'

import { orderFilters } from 'containers/OrderListFilters/filters'

const bulkUpdateOrderPricingByIds = atlas`#graphql
  mutation BulkUpdateOrderPricingByIds(
    $input: BulkUpdateOrderPricingByIdsInput!
  ) {
    bulkUpdateOrderPricingByIds(input: $input) {
      updatedOrdersCount
      notUpdatedOrdersCount
    }
  }
`

export const useBulkUpdateOrderPricingByIds = (orderIds) => {
  const [bulkUpdateOrderPricingByIdsAction] = useMutation(
    bulkUpdateOrderPricingByIds,
    {
      client: atlasClient,
    },
  )
  const onBulkUpdateOrderPricingByIdsAction = async () => {
    const response = await bulkUpdateOrderPricingByIdsAction({
      variables: {
        input: {
          orderIds,
        },
      },
    })
    return response
  }
  return onBulkUpdateOrderPricingByIdsAction
}

export const withUpdateOrderPricingByIdsMutation =
  (WrappedComponent) => (props) => {
    const customProps = {
      ...props,
      handleUpdateOrderPricingByIds: useBulkUpdateOrderPricingByIds(
        props.selectedOrderIds || props.orderIds,
      ),
    }

    return <WrappedComponent {...customProps} />
  }

const batchUpdateOrderPricingByFilters = graphene`#graphql
  mutation BatchUpdateOrderPricingByFilters(
    $input: BatchUpdateOrderPricingByFiltersInput!
  ) {
    batchUpdateOrderPricingByFilters(input: $input) {
      __typename
    }
  }
`

export const withUpdateOrderPricingByFiltersMutation = graphql(
  batchUpdateOrderPricingByFilters,
  {
    alias: 'withUpdateOrderPricingByFiltersMutation',
    options: ({ appliedFilters, searchFilter }) => ({
      variables: {
        appliedFilters: appliedFiltersToGraphQLVariables(
          orderFilters,
          appliedFilters,
        ),
        searchFilter,
      },
    }),
    props: ({ mutate, ownProps: { appliedFilters, searchFilter } }) => ({
      handleUpdateOrderPricingByFilters: () =>
        mutate({
          variables: {
            input: {
              appliedFilters: appliedFiltersToGraphQLVariables(
                orderFilters,
                appliedFilters,
              ),
              searchFilter,
            },
          },
        }),
    }),
  },
)
